import { useCallback, useContext } from 'react';

import { MainContext } from '@ezbobdev/ui-framework';

import { useUtils } from '../../utils/useUtils';

export const useHeader = (props, widgetName) => {
  const { history, onLoginClick } = props;
  const { getConfig, configByName } = useUtils(props, widgetName);
  const { actions, sdkActions } = useContext(MainContext);
  const className = getConfig(`className`);
  const logo = getConfig(`logo`);
  const isLogoCentered = getConfig('isLogoCentered', false);
  const secondaryLogo = getConfig(`secondaryLogo`);
  const isLogoClickable = getConfig('isLogoClickable', true);
  const hasLogoutButton = getConfig('hasLogoutButton', true);
  const position = getConfig('position', 'fixed');
  const variant = getConfig('variant', 'elevation');
  const elevation = getConfig('elevation', 0);
  const color = getConfig('color', 'layout');
  const menu = getConfig('menu');
  const alloWMultilanguages = actions.settings.getUserConfigProp('system.alloWMultilanguages');
  const customerWizardRoute = actions.settings.getPageRoute('customerWizard');

  const help = getConfig('help', actions.settings.getUserConfigProp('custom.help'));
  const exit = getConfig('exit');
  const phone = getConfig('phone');

  const logout = useCallback(async () => {
    try {
      await sdkActions.users.logout(props.overrideLogoutUrl);
    } catch (e) {
      console.error(e);
    }
  }, [props.overrideLogoutUrl]);

  const login = useCallback(async () => {
    if (typeof onLoginClick === 'function') await onLoginClick();

    const customerLoginUrl = actions.settings.getPageRoute('customerLogin.url');
    history.push(customerLoginUrl);
  }, [onLoginClick]);

  return {
    className,
    logo,
    isLogoCentered,
    secondaryLogo,
    logout,
    login,
    position,
    variant,
    elevation,
    color,
    alloWMultilanguages,
    menu,
    configByName,
    isLogoClickable,
    hasLogoutButton,
    customerWizardRoute,
    help,
    exit,
    phone,
    showAtLeastOneLogo: !!(logo || secondaryLogo),
  };
};
